var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBreadcrumbNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46207 5.00026C4.50106 5.0393 4.50107 5.10253 4.4621 5.14158L0.948658 8.66206C0.656059 8.95525 0.656534 9.43013 0.949721 9.72272C1.24291 10.0153 1.71778 10.0148 2.01038 9.72166L6.12334 5.60045C6.41594 5.30727 6.41546 4.83239 6.12228 4.53979C6.1213 4.53882 6.12033 4.53785 6.11935 4.53688L2.01012 0.423089C1.71739 0.130034 1.24251 0.12977 0.949457 0.4225C0.656401 0.715231 0.656137 1.1901 0.948868 1.48316L4.46207 5.00026Z",
    fill: "#C3CBD7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbNext);
export default __webpack_public_path__ + "static/media/breadcrumb-next.9a1cab806b60ae019eb23d366a4f5f57.svg";
export { ForwardRef as ReactComponent };